module.exports = __webpack_public_path__ + "img/congestion-status-dining-hall_even.b40a88a8.svg";